module.exports = __webpack_public_path__ + "fonts/nunito-sans-400-italic-latin-ext.5fb8b9d.woff2";